var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScissorsCut01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scissors-cut-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.4444 3.33333L7.83882 12.9167M7.83882 7.08333L18.4444 16.6667M16.1388 10H16.148M20.2888 10H20.298M5.53327 2.5C7.06126 2.5 8.29993 3.61929 8.29993 5C8.29993 6.38071 7.06126 7.5 5.53327 7.5C4.00528 7.5 2.7666 6.38071 2.7666 5C2.7666 3.61929 4.00528 2.5 5.53327 2.5ZM5.53327 12.5C7.06126 12.5 8.29993 13.6193 8.29993 15C8.29993 16.3807 7.06126 17.5 5.53327 17.5C4.00528 17.5 2.7666 16.3807 2.7666 15C2.7666 13.6193 4.00528 12.5 5.53327 12.5Z",
    stroke: "#0E376E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissorsCut01);
export default __webpack_public_path__ + "static/media/scissors-cut-01.fe02a84e2a1e87a50b3cec0b17abeae3.svg";
export { ForwardRef as ReactComponent };